import React from "react";
import swal from "../../helpers/swal";
import { axiosget } from "../../helpers/httprequest";

const VerifyPayment = ({ v }) => {
  const [loading, setloading] = React.useState(false);
  const _verify = async () => {
    try {
      setloading(true);
      const req = await axiosget(`ms_application_fee/${v.trxcode}`);
      swal(req?.data?.type, req?.data?.message);
      setloading(false);
    } catch ({ message }) {
      swal("error", message);
      setloading(false);
    }
  };
  return (
    <button disabled={loading || v.verified ? true : false} className="btn btn-primary float-right" onClick={_verify}>
      {loading ? (
        <>
          <i className="fa-solid spinner-grow spinner-grow-sm"></i> Verifying Payment...
        </>
      ) : (
        <>
          <i className="fa-solid fa-check-double"></i> Verify Payment
        </>
      )}
    </button>
  );
};

export default VerifyPayment;
